/**
 * Ідентифікатор товарної позиції для PR-звітів: KeyCRM `offer.product_id` або число з префікса SKU.
 * Має збігатися з логікою агрегації колонок у ReportLayout / ReportsSummary.
 */
export function getPidFromSku(sku) {
    if (!sku) return null;
    const base = String(sku).split("-")[0];
    const match = base.match(/\d+/);
    if (!match) return null;
    const n = Number(match[0]);
    return Number.isFinite(n) ? n : null;
}

export function getProductLinePid(product) {
    if (!product || typeof product !== "object") return null;
    const fromOffer = product.offer?.product_id;
    if (fromOffer != null && Number.isFinite(Number(fromOffer))) {
        return Number(fromOffer);
    }
    return getPidFromSku(product.sku);
}
